<div>
    <h2 mat-dialog-title>Edit League</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>League Name</mat-label>
                            <input required matInput name="name" id="name" placeholder="League Name" type="text"
                                formControlName="name" />
                            <mat-error *ngIf="form.get('name').errors?.required">League Name is required</mat-error>
                            <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                {{ form.get("name").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Description</mat-label>
                            <textarea matInput name="description" id="description" placeholder="Description (optional)"
                                rows="3" formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button class="warning" (click)="dialogRef.close('cancel')" [disabled]="isLoading"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>

